import { Component, Input } from '@angular/core';
import { InputDisplay } from '../input-group/input-group.properties';
import { TextFieldComponent } from '../text-field/text-field.component';

@Component({
    selector: 'shared-ui-inputs-text-group',
    templateUrl: './text-group.component.html',
    styleUrls: ['./text-group.component.css'],
    standalone: false
})
export class TextGroupComponent extends TextFieldComponent {
  @Input() display = InputDisplay.Block;

  constructor() {
    super();
  }

  isInline(): boolean {
    return this.display === InputDisplay.Inline;
  }
}
